/*
* Auth used for Dugout
*/

import { CFGet, CFNavTo } from '../util/api';

const testToken = '';

const TOKEN_RECEIVED = 'TOKEN_RECEIVED';
const _init = {
	token: testToken
};

var _token = testToken;

export function authFetchWrapper({ fetchCall, receivedCall, data }, dispatch) {
	let fetchParameters = data.filters ? data.filters : data.body ? data.body : data.parameters ? data.parameters : null;

	return fetchCall(fetchParameters).then(
		response => {
			if (response.status === 401) {
				dispatch(getAuthToken(data.dugoutUrl, data.publicUrl, data.returnPath)).then(
					() => { 
						fetchCall(fetchParameters).then(response => { 
							dispatch(receivedCall(response)) 
							return response; 
						}); 
					}
				);
			}
			else if (response.status === 403) {
				CFNavTo({url: data.dugoutUrl + `/Account/Forbidden`})
			}
			else {
				dispatch(receivedCall(response));
				return response;
			} 
		}
	)
}

export function getAuthToken(dugoutUrl, publicUrl, returnPath) {
	return function(dispatch) {
		return fetchToken(dugoutUrl, publicUrl).then(
			response => {
				if (response.status === 401 || response.status === 302) {
					CFNavTo({url: dugoutUrl + `/Account/LogOn?ReturnUrl=${returnPath}`})
				}
				else {
					dispatch(saveToken(response));
				} 
			}
		);
	}
}

function fetchToken(dugoutUrl, publicUrl) {
	// return return401();

	return CFGet({
		url: dugoutUrl + '/Account/RequestAuthToken',
		originURL: publicUrl,
		loaderName: 'fetchToken'
	});	
}

function saveToken(response) {
	_token = response.token;
	return {
		type: TOKEN_RECEIVED,
		token: response.token
	};
}

async function return401() {
	return { status: 401 }
}

export function reducer(state = _init, action) {
	switch (action.type) {
		case TOKEN_RECEIVED:
		return {
			...state,
			token: action.token
		}
		default:
		return state;
	}
}

export const CFAuthGet = ({ url, params, customHeaders, originURL, loaderName, customQueryParams }) => {
	if (loaderName !== undefined && loaderName !== '') enqueueLoader(loaderName);
	let paramString = '';
	let headers = {
		'Access-Control-Allow-Origin': originURL,
		'Authorization': 'Bearer ' + _token
	};
	
    if(params && Object.keys(params).length > 0)
        paramString = Object.keys(params).map(paramKey => {
            return `${paramKey}=${params[paramKey]}`;
		}).join('&');
	
	if(customQueryParams)
		paramString += customQueryParams;

	if(customHeaders && Object.keys(customHeaders).length > 0) {
		Object.keys(customHeaders).forEach(headerTitle => {
			headers[headerTitle] = customHeaders[headerTitle];
		})
	}

	return fetch(
		url + (paramString !== '' ? `?${paramString}` : ''),
        { 
			credentials: 'include',
            headers: headers
        }
	).then(response => {
		if (loaderName !== undefined && loaderName !== '') dequeueLoader(loaderName);
		return response.ok ? response.json() : response;
	});
} 

export const CFAuthPost = ({ url, body, customHeaders, originURL, loaderName }) => {
	if (loaderName !== undefined && loaderName !== '') enqueueLoader(loaderName);
	let headers = {
		'Access-Control-Allow-Origin': originURL,
		'Content-Type': 'application/json',
		'Authorization': 'Bearer ' + _token
	};

	if(customHeaders && Object.keys(customHeaders).length > 0) {
		Object.keys(customHeaders).forEach(headerTitle => {
			headers[headerTitle] = customHeaders[headerTitle];
		})
	}

	return fetch(
		url,
        { 
			credentials: 'include',
			headers: headers,
			method: 'POST',
			body: JSON.stringify(body)
        }
	).then(response => {
		if (loaderName !== undefined && loaderName !== '') dequeueLoader(loaderName);

		if(response.ok) {
			let returnResponse;
			
			try {
				returnResponse = response.text().then(t => { return t ? JSON.parse(t) : { ok: response.ok } });
			}
			catch(error) {
				return response;
			}
			return returnResponse;
		}
		return response;

	});
} 

export const CFAuthMediaPost = ({ url, body, customHeaders, originURL, loaderName }) => {
	if (loaderName !== undefined && loaderName !== '') enqueueLoader(loaderName);
	let headers = {
		'Access-Control-Allow-Origin': originURL,
		'Authorization': 'Bearer ' + _token
	};

	if(customHeaders && Object.keys(customHeaders).length > 0) {
		Object.keys(customHeaders).forEach(headerTitle => {
			headers[headerTitle] = customHeaders[headerTitle];
		})
	}

	return fetch(
		url,
        { 
			credentials: 'include',
			headers: headers,
			method: 'POST',
			body: body
        }
	).then(response => {
		if (loaderName !== undefined && loaderName !== '') dequeueLoader(loaderName);

		if(response.ok) {
			let returnResponse;

			try {
				returnResponse = response.text().then(t => { return t ? JSON.parse(t) : { ok: response.ok } });
			}
			catch(error) {
				return response;
			}
			return returnResponse;
		}
		return response;

	});
}

export const CFAuthPut = ({ url, params, customHeaders, originURL, loaderName, customQueryParams }) => {
	if (loaderName !== undefined && loaderName !== '') enqueueLoader(loaderName);
	let paramString = '';
	let headers = {
		'Access-Control-Allow-Origin': originURL,
		'Authorization': 'Bearer ' + _token
	};
	
    if(params && Object.keys(params).length > 0)
        paramString = Object.keys(params).map(paramKey => {
            return `${paramKey}=${params[paramKey]}`;
		}).join('&');
	
	if(customQueryParams)
		paramString += customQueryParams;

	if(customHeaders && Object.keys(customHeaders).length > 0) {
		Object.keys(customHeaders).forEach(headerTitle => {
			headers[headerTitle] = customHeaders[headerTitle];
		})
	}

	return fetch(
		url + (paramString !== '' ? `?${paramString}` : ''),
        { 
			credentials: 'include',
			headers: headers,
			method: 'PUT',
        }
	).then(response => {
		if (loaderName !== undefined && loaderName !== '') dequeueLoader(loaderName);

		if(response.ok) {
			let returnResponse;

			try {
				returnResponse = response.text().then(t => { return t ? JSON.parse(t) : { ok: response.ok } });
			}
			catch(error) {
				return response;
			}
			return returnResponse;
		}
		return response;

	});
} 

export const CFAuthPutFix = ({ url, params, body, customHeaders, originURL, loaderName, customQueryParams }) => {
	if (loaderName !== undefined && loaderName !== '') enqueueLoader(loaderName);
	let paramString = '';
	let headers = {
		'Access-Control-Allow-Origin': originURL,
		'Content-Type': 'application/json',
		'Authorization': 'Bearer ' + _token
	};
	
    if(params && Object.keys(params).length > 0)
        paramString = Object.keys(params).map(paramKey => {
            return `${paramKey}=${params[paramKey]}`;
		}).join('&');
	
	if(customQueryParams)
		paramString += customQueryParams;

	if(customHeaders && Object.keys(customHeaders).length > 0) {
		Object.keys(customHeaders).forEach(headerTitle => {
			headers[headerTitle] = customHeaders[headerTitle];
		})
	}

	return fetch(
		url + (paramString !== '' ? `?${paramString}` : ''),
        { 
			credentials: 'include',
			headers: headers,
			method: 'PUT',
			body: JSON.stringify(body)
        }
	).then(response => {
		if (loaderName !== undefined && loaderName !== '') dequeueLoader(loaderName);

		if(response.ok) {
			let returnResponse;

			try {
				returnResponse = response.text().then(t => { return t ? JSON.parse(t) : { ok: response.ok } });
			}
			catch(error) {
				return response;
			}
			return returnResponse;
		}
		return response;

	});
}

export const CFAuthDelete = ({ url, body, customHeaders, originURL, loaderName }) => {
	if (loaderName !== undefined && loaderName !== '') enqueueLoader(loaderName);
	let headers = {
		'Access-Control-Allow-Origin': originURL,
		'Authorization': 'Bearer ' + _token
	};

	if(customHeaders && Object.keys(customHeaders).length > 0) {
		Object.keys(customHeaders).forEach(headerTitle => {
			headers[headerTitle] = customHeaders[headerTitle];
		})
	}

	return fetch(
		url,
        { 
			credentials: 'include',
			headers: headers,
			method: 'DELETE',
			body: body
        }
	).then(response => {
		if (loaderName !== undefined && loaderName !== '') dequeueLoader(loaderName);

		if(response.ok) {
			let returnResponse;

			try {
				returnResponse = response.text().then(t => { return t ? JSON.parse(t) : { ok: response.ok } });
			}
			catch(error) {
				return response;
			}
			return returnResponse;
		}
		return response;
	});
}



// WEBPACK FOOTER //
// ./src/auth/auth_actions.js